<template>
  <div class="dropdown">
    <div class="dropdown__target">
      <slot name="target"></slot>
    </div>
    <div class="dropdown__menu" :class="{ 'open': isOpen }">
      <slot name="menu"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "dropdown",
  props: ["isOpen"],
}
</script>

<style scoped lang="scss">

</style>
